import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendFundTransferDc } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const FundTransferDirectCredit = (props) => {
  const {
    goToFundTransferAdviceDirectCredit,
    goToBalanceEnquiry,
    sendType,
    fundTransferDc,
    isLoading,
  } = props;

  const handleFundTransferDc1 = () => {
    const payload = {
      type: "success",
    };
    sendType(payload);
  };

  const handleFundTransferDc2 = () => {
    const payload = {
      type: "balance_enquiry",
    };
    sendType(payload);
  };

  const request = fundTransferDc && fundTransferDc.request;
  const response = fundTransferDc && fundTransferDc.response;

  return (
    <InwardXml
      prev={goToBalanceEnquiry}
      next={goToFundTransferAdviceDirectCredit}
      title={"Fund Transfer Direct Credit"}
      request={request}
      response={response}
      optiontitle1={"Sucess"}
      optiontitle2={"Balance Enquiry (BE)"}
      handleCase1={handleFundTransferDc1}
      handleCase2={handleFundTransferDc2}
      isLoading={isLoading}
    />
  );
};

FundTransferDirectCredit.propTypes = {
  fundTransferDc: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  goToBalanceEnquiry: PropTypes.func,
  goToFundTransferAdviceDirectCredit: PropTypes.func,
  isLoading: PropTypes.bool,
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendFundTransferDcSuccess:
      state.inwardInteraction.sendFundTransferDcSuccess,
    fundTransferDc: state.inwardInteraction.sendFundTransferDc,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendFundTransferDc(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundTransferDirectCredit);
